// Unified Router - Combines MOPUI and MoceroUI routes into single application
import type { RouteRecordRaw } from 'vue-router';

// MOPUI Components (existing)
import LoginDashboard from '../views/dashboard/loginDashboard.vue';
import AuthLogin from '../views/auth/LoginView.vue';

// Import MOPUI accounts routes
import { accountsRoutes } from '../modules/accounts/router/index';

// Import MoceroUI Components directly into MOPUI
// CRM Components
import CRMLayout from '../../../MoceroUI/src/modules/crm/components/Layout/Header.vue';
import CRMDashboard from '../../../MoceroUI/src/modules/crm/pages/dashboard/dashboard.vue';
import CRMLogin from '../../../MoceroUI/src/modules/crm/pages/Login/login.vue';

// Inventory Components
import InventoryLayout from '../../../MoceroUI/src/modules/Inventory/components/Layout/Header.vue';
import InventoryMasters from '../../../MoceroUI/src/modules/Inventory/pages/MastersforInventory/MastersforInventory.vue';

// Import all MoceroUI Inventory routes
import { inventryrouter } from '../../../MoceroUI/src/modules/Inventory/router/index';

// User Management Components
import UserManagementLayout from '../../../MoceroUI/src/modules/userManagement/components/Layout/Header.vue';
import UserManagementDashboard from '../../../MoceroUI/src/modules/userManagement/pages/dashboard.vue';
import { TaskRoutes } from '../modules/TaskManagement/router/router'

export const unifiedRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/auth/login'
    },

    // Unified Authentication Routes
    {
        path: '/auth',
        children: [
            {
                path: 'login',
                name: 'Login',
                component: AuthLogin // Use MOPUI login as primary
            }
        ]
    },

    // Unified Dashboard
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: LoginDashboard,
        meta: { requiresAuth: true }
    },

    // Direct redirect for /accounts to MOPLayout
    {
        path: '/accounts',
        redirect: '/MOPLayout/accounts'
    },

    // MOPUI Routes (Modern Modules) - All routes go through MOPLayout
    {
        path: '/MOPLayout',
        name: 'MOPLayout',
        component: () => import('../Layout/MOPLayout.vue'),
        meta: { requiresAuth: true, moduleType: 'mopui' },
        children: [
            ...accountsRoutes.map(route => ({
                ...route,
                // Remove the leading '/accounts' from the path since it will be nested under MOPLayout
                path: route.path === '/accounts' ? 'accounts' : route.path?.replace('/accounts/', 'accounts/') || route.path,
                meta: { requiresAuth: true, moduleType: 'mopui', ...(route.meta || {}) }
            })),
            ...TaskRoutes
        ]
    },

    // MoceroUI Routes (Legacy Modules) - Integrated directly
    {
        path: '/crm',
        name: 'CRMModule',
        component: CRMLayout,
        meta: { requiresAuth: true, moduleType: 'moceroui' },
        children: [
            {
                path: '',
                redirect: '/crm/dashboard'
            },
            {
                path: 'dashboard',
                name: 'CRMDashboard',
                component: CRMDashboard,
                meta: { requiresAuth: true }
            }
        ]
    },

    // Add all MoceroUI Inventory routes directly
    ...inventryrouter.map(route => ({
        ...route,
        meta: { requiresAuth: true, moduleType: 'moceroui', ...route.meta }
    })),

    {
        path: '/user-management',
        name: 'UserManagementModule',
        component: UserManagementLayout,
        meta: { requiresAuth: true, moduleType: 'moceroui' },
        children: [
            {
                path: '',
                redirect: '/user-management/dashboard'
            },
            {
                path: 'dashboard',
                name: 'UserManagementDashboard',
                component: UserManagementDashboard,
                meta: { requiresAuth: true }
            }
        ]
    },

    // Legacy route redirects for backward compatibility
    {
        path: '/Layout/dashboard',
        redirect: '/crm/dashboard'
    },
    {
        path: '/InventoryLayout',
        redirect: '/inventory'
    },
    {
        path: '/InventoryLayout/Masters',
        redirect: '/inventory/masters'
    },
    {
        path: '/billingLayout/userdashboard',
        redirect: '/user-management/dashboard'
    }
];
